import { inject, Injectable } from '@angular/core';
import { TrackingService } from '@app/services/tracking.service';
import { ApiGateway } from '@sb/shared/api';
import { ModalBundle } from '@shiftbase-com/ts-shared/models';

import { UserGuideType } from '../../../reducers/orm/user-guide/user-guide.model';
import { SmbHospitalityOnboardingChecklistStep } from '../../../shared/onboarding/onboarding-checklist.model';
import { OnboardingChecklistService } from '../../../shared/onboarding/onboarding-checklist.service';
import { OnboardingAbsenceManagementRequest } from './absence-management.model';

@Injectable({
  providedIn: 'root',
})
export class OnboardingAbsenceManagementService {
  #onboardingChecklist = inject(OnboardingChecklistService);
  #api = inject(ApiGateway);
  #trackingService = inject(TrackingService);

  savePreferences(payload: OnboardingAbsenceManagementRequest) {
    return this.#api.post('onboarding/absence_management', payload);
  }

  completeChapter(eventData: ModalBundle) {
    this.#trackingService.event('Onboarding Absence Management Completed', eventData);

    return this.#onboardingChecklist.completeStep(
      UserGuideType.SELF_ONBOARDING_CHECKLIST,
      SmbHospitalityOnboardingChecklistStep.ABSENCE_MANAGEMENT,
    );
  }
}
